<template>
    <label class="flex-form__field" :class="getInvalidClass('eventName')">
        <div class="flex-form__label">
            Event Name
        </div>

        <input v-model="dataNew.eventName" class="flex-form__input">
    </label>
</template>

<script>
import eventDataMixin from '@/mixins/event-data';

export default {
    name: 'trigger-flex-event',
    mixins: [eventDataMixin],

    data() {
        return {
            schema: {
                eventName: {
                    type: String,
                    default: '',
                    required: true,
                },
            },
        };
    },
};
</script>
